import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]
  static values = {
    url: String,
    checkInsUrl: String,
    instanceIds: Array
  }

  connect() {
    this.debounceTimer = null
  }

  search() {
    clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.fetchResults(), 150)
  }

  async fetchResults() {
    const q = this.inputTarget.value.trim()
    if (q.length < 2) {
      this.resultsTarget.innerHTML = '<p class="text-center text-white/40 py-8">Type at least 2 characters</p>'
      return
    }

    this.resultsTarget.innerHTML = '<p class="text-center text-white/40 py-8">Searching…</p>'

    const url = `${this.urlValue}?q=${encodeURIComponent(q)}`
    const response = await fetch(url, { headers: { "Accept": "text/html" } })
    const html = await response.text()
    this.resultsTarget.innerHTML = html
  }

  checkIn(event) {
    event.preventDefault()
    const memberId = event.currentTarget.dataset.memberId
    if (!memberId) return

    const form = document.createElement("form")
    form.method = "POST"
    form.action = this.checkInsUrlValue
    form.style.display = "none"

    const token = document.querySelector("[name='csrf-token']")
    if (token) {
      const input = document.createElement("input")
      input.name = "authenticity_token"
      input.value = token.content
      input.type = "hidden"
      form.appendChild(input)
    }

    ;[
      [ "member_id", memberId ],
      [ "pin", "" ]
    ].forEach(([ name, value ]) => {
      const input = document.createElement("input")
      input.name = name
      input.value = value
      input.type = "hidden"
      form.appendChild(input)
    })

    const ids = this.hasInstanceIdsValue ? this.instanceIdsValue : []
    ids.forEach((id) => {
      const input = document.createElement("input")
      input.name = "instance_ids[]"
      input.value = String(id)
      input.type = "hidden"
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
  }
}
